import { render, staticRenderFns } from "./CreditPayment.vue?vue&type=template&id=3223a55e&scoped=true"
import script from "./CreditPayment.vue?vue&type=script&lang=js"
export * from "./CreditPayment.vue?vue&type=script&lang=js"
import style0 from "./CreditPayment.vue?vue&type=style&index=0&id=3223a55e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3223a55e",
  null
  
)

export default component.exports